import { Button } from "@/shared/components/ui/button";
import { FunnelX } from "lucide-react";

export default function FilterEmpty({
  onClearFilters,
}: {
  onClearFilters: () => void;
}) {
  return (
    <>
      <div className="w-[36px] h-[36px] rounded-[8px] mb-[15px] bg-white border border-border flex items-center justify-center">
        <FunnelX height={20} width={20} color="#09090B" />
      </div>
      <h3 className="text-base font-semibold mb-[4px]">
        Seçili filtrelere uygun sonuç bulunamadı.
      </h3>
      <p className="text-[14px] font-600 text-muted-foreground">
        Filtreleri temizleyin veya aramayı değiştirin.
      </p>

      <div className="mt-[15px]">
        <Button size="sm" onClick={onClearFilters}>
          Filtreyi temizle
        </Button>
      </div>
    </>
  );
}
